<template>
  <span v-if="districts.length" class="client-districts">
    <span
      v-for="district in districts"
      :key="district"
      class="district-badge"
      :title="`Okres nehnuteľnosti: ${district}`"
    >
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true">
        <path d="M20 10c0 6-8 11-8 11S4 16 4 10a8 8 0 1 1 16 0Z" />
        <circle cx="12" cy="10" r="2.5" />
      </svg>
      <span>Okres {{ district }}</span>
    </span>
  </span>
</template>

<script>
import {clientDistricts} from "../../../utils/clientDistricts";

export default {
  name: "ClientDistrictBadges",
  props: {client: Object},
  computed: {
    districts() {
      return clientDistricts(this.client, this.$store.state.clientState.propertyDistricts);
    },
  },
};
</script>

<style scoped>
.client-districts {
  display: contents;
}

.district-badge {
  display: inline-flex;
  max-width: 100%;
  padding: 3px 7px;
  align-items: center;
  gap: 4px;
  border: 1px solid var(--app-border);
  border-radius: 6px;
  background: var(--app-surface-muted);
  color: var(--app-text-muted);
  font-size: 10px;
  font-weight: 600;
  line-height: 1.3;
  overflow-wrap: anywhere;
}

.district-badge svg {
  width: 12px;
  height: 12px;
  flex: 0 0 12px;
}
</style>
